export default "/_next/static/media/air-jordan-1-mid-se-shoes-hHltxp.025788e39d6a5ef36ad2cec2b7cdd8dc.jpeg";